import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from 'react-router-dom';
import {
    Button, Box, Card, CardContent, FormHelperText, Grid, Typography, TextField, IconButton, InputLabel, Select
    , MenuItem, FormControl,
} from '@mui/material';
import axios from 'axios';
import swal from 'sweetalert';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import { useDeadline } from '../../../../contexts/DeadlineContext';

const AffiliationCparticipnatBadge = () => {
    const history = useHistory();
    const gradientBackground = '#05597D';
    const { abstractHomeSetup } = useDeadline();
    const eventid = localStorage.getItem('eventid');
    const [disabled, setDisabled] = useState(false);
    const [conferenceAffiliationBadgeImage, setConferenceAffiliationBadgeImage] = useState("");
    const [eventOptionsSetup, setEventOptionsSetup] = useState({
        conferenceAffiliationBadgeImage: "",
        participant_register_status: "",
        error_list: [],
    });


    const fileInputRef = useRef(null);

    useEffect(() => {
        axios.get(`api/index-option-setup?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getOptionsData = res.data.getOptions;
                setEventOptionsSetup(getOptionsData);
            }
        });
    }, [eventid]);



    const handleAffiliationBadgeChange = (e) => {
        setConferenceAffiliationBadgeImage(e.target.files[0]);
    };

    const handleParticpantsRegisterActionChange = (e) => {
        setEventOptionsSetup({ ...eventOptionsSetup, [e.target.name]: e.target.value });
    }

    const optionAffiliationSubmit = (e) => {
        e.preventDefault();
        const data = {
            eventid,
            conferenceAffiliationBadgeImage,

        };
        console.log(data);

        setDisabled(true);
        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/add-option-setup`, data, config).then(res => {
                if (res.data.status === 200) {
                    swal('Success', res.data.message, 'success');
                    // Refresh the options setup data after successful submission
                    axios.get(`api/index-option-setup?id=${eventid}`).then(res => {
                        if (res.status === 200) {
                            const getOptionsData = res.data.getOptions;
                            setEventOptionsSetup(getOptionsData);
                        }
                    });
                    setDisabled(false);
                    setConferenceAffiliationBadgeImage("");
                    // Clear the file input
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                } else {
                    setEventOptionsSetup({ ...eventOptionsSetup, error_list: res.data.validate_error });
                }
            });
        });
    };

    let backGroundButtonByEvent = eventid ? abstractHomeSetup.color_code_two : '#145348';
    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }}>
                    <Button
                        sx={{
                            float: 'right',
                            marginTop: '2%',
                            background: abstractHomeSetup.color_code_two || gradientBackground,
                            ":hover": { color: "white" }
                        }}
                        color='success'
                        size='small'
                        variant='contained'
                        onClick={() => history.goBack()}
                    >
                        Back
                    </Button>
                </h4>
                <Card sx={{ width: '60vw', float: 'center' }}>
                    <CardContent>
                        <Typography component="h1" variant="h5">
                            Affiliate Conference Badge
                        </Typography>
                        <Box component="form" onSubmit={optionAffiliationSubmit} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={2}>

                                <Grid item xs={6}>
                                    <label htmlFor="icon-button-file">
                                        <input
                                            accept="image/*"
                                            id="icon-button-file"
                                            type="file"
                                            onChange={handleAffiliationBadgeChange}
                                            style={{ display: 'none' }}
                                            name="[licenseFile]"
                                            ref={fileInputRef}
                                        />
                                        <IconButton color="primary" aria-label="upload picture" component="span">
                                            <PhotoCamera />
                                        </IconButton>
                                        Upload Conference Affiliation Badge
                                    </label>
                                    <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                                        Recommended image size: 1536px (width) × 1024px (height)
                                        <br></br>
                                        Extention: jpg  
                                    </Typography>

                                    <FormHelperText>
                                        {eventOptionsSetup.error_list?.conference_affiliation_badge
                                            ? `${eventOptionsSetup.error_list?.conference_affiliation_badge} width=1920, height=1160`
                                            : ""}
                                    </FormHelperText>

                                    <div>
                                        {eventOptionsSetup?.conference_affiliation_badge !== "no_image.jpg" && eventOptionsSetup?.conference_affiliation_badge && (
                                            <img
                                                src={eventOptionsSetup?.conference_affiliation_badge}
                                                width="800"
                                                height="600"
                                                alt="Affiliation Conference Badge"
                                            />
                                        )}
                                    </div>
                                </Grid>

                            </Grid>

                            <Grid container justifyContent="flex-end">
                                <Button
                                    disabled={disabled}
                                    type="submit"
                                    variant="contained"
                                    sx={{ mt: 5, background: abstractHomeSetup.color_code_two || gradientBackground, }}
                                >
                                    Submit
                                </Button>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
}

export default AffiliationCparticipnatBadge;
